import { Fragment, ReactElement, ReactNode } from 'react';

const isNotAReactComponent = (content: ReactNode) =>
    content &&
    ((typeof content === 'object' && 'type' in content && content.type === Fragment) || !(typeof content === 'object'));

export const isFragmentContent = (content: ReactNode): boolean =>
    typeof content === 'object' &&
    content !== null &&
    'type' in (content as object) &&
    (content as ReactElement).type === Fragment;

export default isNotAReactComponent;
